export default "__VITE_ASSET__DEt8g4sP__"